import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {
    getMindmalLayoutCenter,
    getMindmalLayoutTB,
    getMindmapLayoutLR,
    IconClose,
    IconDropdownSelected
} from "../../Icon";
import {Button, Checkbox, ConfigProvider, message, Modal, Select, Slider} from "antd";
import {t} from "i18next";
import './DialogMindmapStyleSetting.css'
import ChooseFont from "../../../@excalidraw/packages/excalidraw/components/ExtendView/ChooseFont";
import NumberInput from "@/views/Dialog/components/NumberInput";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import {EVENT_FORCE_UPDATE_MINDMAP, KEY_FILE_DIR, KEY_MINDMAP_STYLE_CONFIG} from "@/Const";
import {
    DEFAULT_MINDMAP_CONFIG, getMindmapThemeConfig,
    mindMapCache, recursionRoot
} from "../../../@excalidraw/packages/excalidraw/element/mindMap";
import {mutateElement} from "../../../@excalidraw/packages/excalidraw";
import {getImagePathWithThemeSvg, isDarkMode} from "@/utils";

const DialogMindmapStyleSetting = forwardRef((props:{onCloseCallback:any}, ref) => {
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog
    }))
    const [isShowDialog, setIsShowDialog] = useState(false);
    const [mindmapConfig,setMindmapConfig] = useState(DEFAULT_MINDMAP_CONFIG);

    const mElement = useRef(null);

    const ARRAY_LINE_TYPE = [
        {
            label:t("Square_1"),
            value:'straight'
        },
        {
            label:t("Curve"),
            value:'curve'
        },
        {
            label:t("Direct"),
            value:'direct'
        }
    ]

    useEffect(() => {
        const config:any = localStorage.getItem(KEY_MINDMAP_STYLE_CONFIG);
        if (config){
            setMindmapConfig(JSON.parse(config));
        }
    }, []);

    const onShowDialog = (element:any)=>{
        mElement.current = element;
        setIsShowDialog(true);
        if (element?.config){
            setMindmapConfig(element.config);
        }
    }

    const isSelectLayout = (szLayout:any)=>{
        return mindmapConfig.layout == szLayout;
    }

    const isSelectLayoutLR = ()=>{
        return isSelectLayout('logicalStructure')
    }
    const isSelectLayoutTB = ()=>{
        return isSelectLayout('organizationStructure')
    }
    const isSelectLayoutCenter = ()=>{
        return isSelectLayout('mindMap')
    }

    return <ConfigProvider
        theme={{
            components: {
                Modal: {
                    contentBg:'var(--dialog-dialog-background-color-2c)',
                    colorText:'var(--text-color)',
                    boxShadow:'var(--box-shadow-popover)'
                },
            },
        }}
    >
        <Modal width={520} zIndex={2005} bodyStyle={{}}
               afterClose={() => {
                   props.onCloseCallback();
               }}
               open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={null}
               onCancel={() => {
                   setIsShowDialog(false)
               }}>
            <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
                <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                    <span className={'dialog-title-large'}>{t('MindmapStyleSetting')}</span>
                    <div style={{flexGrow: '1'}}/>
                </div>
                <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>
                <span className={'dialog-title'}>{t("Layout")}</span>
                <div className={'flex-row-vertical-center mt-6'} style={{justifyContent: 'space-between',gap:'12px'}}>
                    <div className={'mindmap-layout-item'} style={{border:`1px solid ${isSelectLayoutLR()?'var(--mindmap-layout-select-border-color)':'var(--line-color)'}`,background:isSelectLayoutLR()?'var(--mindmap-layout-select-background-color)':'var(--mindmap-layout-no-select-background-color)'}} onClick={()=>{
                        const newConfig = {...mindmapConfig};
                        newConfig.layout = 'logicalStructure';
                        setMindmapConfig(newConfig);
                    }}>
                        {
                            isDarkMode()?<img className={'img-30'} src={getImagePathWithThemeSvg('mindmap_layout_lr')}/>:
                                getMindmapLayoutLR(isSelectLayoutLR()?'var(--primary-color)':'#666666')
                        }
                    </div>
                    <div className={'mindmap-layout-item'} style={{border:`1px solid ${isSelectLayoutTB()?'var(--mindmap-layout-select-border-color)':'var(--line-color)'}`,background:isSelectLayoutTB()?'var(--mindmap-layout-select-background-color)':'var(--mindmap-layout-no-select-background-color)'}} onClick={()=>{
                        const newConfig = {...mindmapConfig};
                        newConfig.layout = 'organizationStructure';
                        setMindmapConfig(newConfig);
                    }}>
                        {
                            isDarkMode()?<img className={'img-30'} src={getImagePathWithThemeSvg('mindmap_layout_tb')}/>:
                                getMindmalLayoutTB(isSelectLayoutTB()?'var(--primary-color)':'#666666')
                        }
                    </div>
                    {/*<div className={'mindmap-layout-item'} style={{border:`1px solid ${isSelectLayoutCenter()?'var(--mindmap-layout-select-border-color)':'var(--line-color)'}`,background:isSelectLayoutCenter()?'var(--mindmap-layout-select-background-color)':'var(--mindmap-layout-no-select-background-color)'}} onClick={()=>{*/}
                    {/*    const newConfig = {...mindmapConfig};*/}
                    {/*    newConfig.layout = 'mindMap';*/}
                    {/*    setMindmapConfig(newConfig);*/}
                    {/*}}>*/}
                    {/*    {*/}
                    {/*        isDarkMode()?<img className={'img-30'} src={getImagePathWithThemeSvg('mindmap_layout_double')}/>:*/}
                    {/*            getMindmalLayoutCenter(isSelectLayoutCenter()?'var(--primary-color)':'#666666')*/}
                    {/*    }*/}
                    {/*</div>*/}
                </div>

                <span className={'mt-24'}>{t("Font")}</span>
                <div className={'mt-6'}
                     style={{width: '100%', border: '1px solid var(--line-color)', borderRadius: '8px'}}>
                    <ChooseFont onFontFamilyChange={(e) => {
                        const newConfig = {...mindmapConfig};
                        newConfig.fontFamily = e;
                        setMindmapConfig(newConfig);
                    }} defaultFontFamily={mindmapConfig.fontFamily} dropDownWidth={'470px'}/>
                </div>

                <div className={'flex-row-vertical-center mt-24'}>
                    <span>{t("RootFontSize")}</span>
                    <div className={'mindmap-number-input'}>
                        <NumberInput defaultValue={mindmapConfig.fontSize} onInputOk={(e) => {
                            const newConfig = {...mindmapConfig};
                            newConfig.fontSize = e;
                            setMindmapConfig(newConfig);
                        }}/>
                    </div>
                </div>
                <Slider value={mindmapConfig.fontSize} style={{margin: '16px 0px'}} onChange={(e)=>{
                    const newConfig = {...mindmapConfig};
                    newConfig.fontSize = e;
                    setMindmapConfig(newConfig);
                }}/>

                <div className={'flex-row-vertical-center mt-24'}>
                    <span>{t("SubnodeFontSize")}</span>
                    <div className={'mindmap-number-input'}>
                        <NumberInput defaultValue={mindmapConfig.subnodeFontSize} onInputOk={(e) => {
                            const newConfig = {...mindmapConfig};
                            newConfig.subnodeFontSize = e;
                            setMindmapConfig(newConfig);
                        }}/>
                    </div>
                </div>
                <Slider value={mindmapConfig.subnodeFontSize} style={{margin: '16px 0px'}} onChange={(e)=>{
                    const newConfig = {...mindmapConfig};
                    newConfig.subnodeFontSize = e;
                    setMindmapConfig(newConfig);
                }}/>

                <div className={'flex-row-vertical-center mt-24'}>
                    <span>{t("Line Thickness")}</span>
                    <div className={'mindmap-number-input'}>
                        <NumberInput defaultValue={mindmapConfig.lineWidth} onInputOk={(e) => {
                            const newConfig = {...mindmapConfig};
                            newConfig.lineWidth = e;
                            setMindmapConfig(newConfig);
                        }}/>
                    </div>
                </div>
                <Slider value={mindmapConfig.lineWidth} style={{margin: '16px 0px'}} onChange={(e)=>{
                    const newConfig = {...mindmapConfig};
                    newConfig.lineWidth = e;
                    setMindmapConfig(newConfig);
                }}/>

                <div className={'flex-row-vertical-center mt-24'}>
                    <span>{t("Line style")}</span>
                    <Select style={{minWidth:'120px',marginLeft:'auto'}}
                            dropdownStyle={{border:'1px solid var(--border-color)'}}
                            options={ARRAY_LINE_TYPE}
                            value={mindmapConfig.lineStyle}
                            onChange={(e)=>{
                                const newConfig = {...mindmapConfig};
                                newConfig.lineStyle = e;
                                setMindmapConfig(newConfig);
                            }}
                            suffixIcon={<IconDropdownSelected/>}>

                    </Select>
                </div>

                <Checkbox className={'mt-24'} value={mindmapConfig.isDefault} style={{color:'var(--text-color)'}} onChange={(e)=>{
                    const newConfig = {...mindmapConfig};
                    newConfig.isDefault = e.target.checked;
                    setMindmapConfig(newConfig);
                }}>
                    {t("SetAsDefault")}
                </Checkbox>


                <div className={'flex-center mt-32 mb-4'}>
                    <Button
                        style={{height: '34px', minWidth: '120px'}}
                        className='large-w-button button-border-gray-style font-size-14 font-family-medium'
                        onClick={() => {
                            setIsShowDialog(false);
                        }}>{t("Cancel")}</Button>
                    <Button
                        // disabled={isStringNullOrEmpty(selectFile)}
                        className='large-w-button button-solid-style font-size-14 font-family-medium'
                        type="primary"
                        onClick={async () => {
                            localStorage.setItem(KEY_MINDMAP_STYLE_CONFIG,JSON.stringify(mindmapConfig));
                            //修改当前mindmap的配置.
                            if (mElement.current) {
                                mElement.current.config = {...mindmapConfig};
                                //更改后会执行到render_end 会有一个mindmap的数据刷新的.
                                // postMessage(EVENT_FORCE_UPDATE_MINDMAP,mElement.current);
                                // mutateElement(mElement.current,{config:mindmapConfig})
                            }
                            const currentMindMap = mindMapCache.get(mElement.current?.id)!;
                            currentMindMap.setLayout(mindmapConfig.layout);

                            Object.values(currentMindMap.renderer.nodeCache).forEach(
                                (node: any) => {
                                    node.setStyles({
                                        fontFamily:mindmapConfig.fontFamily,
                                        fontSize:node.isRoot?mindmapConfig.fontSize:mindmapConfig.subnodeFontSize,
                                    })
                                },
                            );

                            const newConfig = getMindmapThemeConfig(mElement.current);
                            currentMindMap.setThemeConfig(newConfig);

                            props.onCloseCallback();
                        }}
                        style={{
                            marginLeft: '12px',
                            minWidth: '120px'
                        }}>{t("Save")}</Button>
                </div>

            </div>
        </Modal>
    </ConfigProvider>
})

export default DialogMindmapStyleSetting;






















